/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASEDialog from "../../../@BASE/core/BASEDialog";
import { styled } from "@mui/material/styles";
import BASEMessage from "../../../@BASE/core/BASEMessage";
import BASESuspense from "../../../@BASE/core/BASESuspense";
import AppContext from "../../AppContext";
import { memo, useContext } from "react";
import { useSelector } from "react-redux";
import { useRoutes } from "react-router-dom";
import { selectBASECurrentLayoutConfig } from "../../store/BASE/settingsSlice";
import FooterLayout from "./components/FooterLayout";
import LeftSideLayout from "./components/LeftSideLayout";
import NavbarWrapperLayout from "./components/NavbarWrapperLayout";
import RightSideLayout from "./components/RightSideLayout";
import ToolbarLayout from "./components/ToolbarLayout";

const Root = styled("div")(({ theme, config }) => ({
  ...(config.mode === "boxed" && {
    clipPath: "inset(0)",
    maxWidth: `${config.containerWidth}px`,
    margin: "0 auto",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  }),
  ...(config.mode === "container" && {
    "& .container": {
      maxWidth: `${config.containerWidth}px`,
      width: "100%",
      margin: "0 auto",
    },
  }),
}));

function Layout(props) {
  const config = useSelector(selectBASECurrentLayoutConfig);
  const appContext = useContext(AppContext);
  const { routes } = appContext;

  return (
    <Root id="base-layout" config={config} className="w-full flex">
      {config.leftSidePanel.display && <LeftSideLayout />}

      <div className="flex flex-auto min-w-0">
        {config.navbar.display && config.navbar.position === "left" && (
          <NavbarWrapperLayout />
        )}

        <main
          id="base-main"
          className="flex flex-col flex-auto min-h-full min-w-0 relative z-10"
        >
          {config.toolbar.display && (
            <ToolbarLayout
              className={config.toolbar.style === "fixed" && "sticky top-0"}
            />
          )}

          <div className="flex flex-col flex-auto min-h-0 relative z-10">
            <BASEDialog />

            <BASESuspense>{useRoutes(routes)}</BASESuspense>

            {props.children}
          </div>

          {config.footer.display && (
            <FooterLayout
              className={config.footer.style === "fixed" && "sticky bottom-0"}
            />
          )}
        </main>

        {config.navbar.display && config.navbar.position === "right" && (
          <NavbarWrapperLayout />
        )}
      </div>

      {config.rightSidePanel.display && <RightSideLayout />}
      <BASEMessage />
    </Root>
  );
}

export default memo(Layout);
